import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html, body {
    font-family: 'DM Sans', sans-serif;
    background: #0A0A0F;
    color: #E8E6F0;
    scroll-behavior: smooth;
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(28px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes spin { to { transform: rotate(360deg); } }
  @keyframes marquee {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
  @keyframes pulse {
    0%, 100% { opacity: 0.4; transform: scale(1); }
    50% { opacity: 0.8; transform: scale(1.04); }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
  }
  @keyframes glowPulse {
    0%, 100% { box-shadow: 0 0 20px rgba(255,110,60,0.2); }
    50% { box-shadow: 0 0 40px rgba(255,110,60,0.5); }
  }
  @keyframes borderRotate {
    to { --angle: 360deg; }
  }
  @keyframes scanLine {
    0% { top: 0%; }
    100% { top: 100%; }
  }

  .fade-1 { animation: fadeUp 0.7s 0.05s cubic-bezier(0.16,1,0.3,1) both; }
  .fade-2 { animation: fadeUp 0.7s 0.15s cubic-bezier(0.16,1,0.3,1) both; }
  .fade-3 { animation: fadeUp 0.7s 0.25s cubic-bezier(0.16,1,0.3,1) both; }
  .fade-4 { animation: fadeUp 0.7s 0.35s cubic-bezier(0.16,1,0.3,1) both; }
  .fade-5 { animation: fadeUp 0.7s 0.45s cubic-bezier(0.16,1,0.3,1) both; }

  /* NAVBAR */
  .hn-nav {
    position: sticky; top: 0; z-index: 200;
    background: rgba(10,10,15,0.85);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(255,255,255,0.06);
    height: 68px; display: flex; align-items: center;
    justify-content: space-between; padding: 0 40px;
    transition: all 0.3s ease;
  }
  .hn-nav.scrolled {
    background: rgba(10,10,15,0.97);
    border-bottom-color: rgba(255,110,60,0.15);
  }
  .hn-logo {
    font-family: 'Poppins', sans-serif;
    font-size: 22px; font-weight: 800; letter-spacing: -0.5px;
    color: #fff; text-decoration: none;
    display: flex; align-items: center; gap: 4px;
    cursor: pointer;
  }
  .hn-logo span { color: #FF6E3C; }
  .hn-logo-dot {
    width: 7px; height: 7px;
    background: #FF6E3C;
    border-radius: 50%;
    display: inline-block;
    margin-left: 1px;
    animation: pulse 2s ease infinite;
  }

  .hn-nav-links { display: flex; align-items: center; gap: 4px; }
  .hn-nav-link {
    font-size: 13.5px; font-weight: 500;
    color: rgba(255,255,255,0.55);
    padding: 8px 16px; border-radius: 8px;
    cursor: pointer; text-decoration: none;
    transition: all 0.2s ease;
    background: none; border: none;
    font-family: 'DM Sans', sans-serif;
    letter-spacing: 0.01em;
  }
  .hn-nav-link:hover { color: #fff; background: rgba(255,255,255,0.07); }
  .hn-nav-link.active { color: #FF6E3C; background: rgba(255,110,60,0.1); }

  .dropdown { position: relative; display: inline-block; }
  .dropdown-btn {
    font-size: 13.5px; font-weight: 500;
    color: rgba(255,255,255,0.55);
    padding: 8px 16px; border-radius: 8px;
    cursor: pointer; background: none; border: none;
    font-family: 'DM Sans', sans-serif;
    display: flex; align-items: center; gap: 6px;
    transition: all 0.2s;
  }
  .dropdown-btn:hover { color: #fff; background: rgba(255,255,255,0.07); }
  .dropdown-content {
    position: absolute; top: 48px; left: 0;
    background: #16161E;
    min-width: 200px;
    border-radius: 12px;
    border: 1px solid rgba(255,255,255,0.09);
    box-shadow: 0 20px 60px rgba(0,0,0,0.5);
    opacity: 0; visibility: hidden;
    transform: translateY(-6px);
    transition: all 0.2s ease;
    z-index: 100;
  }
  .dropdown-content.open { opacity: 1; visibility: visible; transform: translateY(0); }
  .dropdown-content a {
    display: flex; align-items: center; gap: 10px;
    padding: 11px 16px; text-decoration: none;
    font-size: 13px; color: rgba(255,255,255,0.6);
    font-weight: 500; transition: all 0.15s;
    border-bottom: 1px solid rgba(255,255,255,0.05);
    cursor: pointer;
  }
  .dropdown-content a:last-child { border-bottom: none; }
  .dropdown-content a:hover { background: rgba(255,110,60,0.1); color: #FF6E3C; }

  .hn-nav-right { display: flex; align-items: center; gap: 10px; }

  /* Ticker */
  .ticker-bar {
    background: #FF6E3C;
    padding: 10px 0; overflow: hidden; white-space: nowrap;
  }
  .ticker-track { display: inline-flex; gap: 0; animation: marquee 22s linear infinite; }
  .ticker-item {
    font-size: 12.5px; font-weight: 600;
    color: #fff; padding: 0 32px;
    display: inline-flex; align-items: center; gap: 8px;
    letter-spacing: 0.02em;
  }
  .ticker-dot { color: rgba(255,255,255,0.5); }

  /* Buttons */
  .btn-primary {
    display: inline-flex; align-items: center; gap: 8px;
    padding: 13px 28px; font-size: 14.5px; font-weight: 600;
    background: #FF6E3C; color: #fff;
    border: none; border-radius: 10px;
    cursor: pointer; font-family: 'DM Sans', sans-serif;
    transition: all 0.2s ease;
    letter-spacing: 0.01em;
    animation: glowPulse 3s ease infinite;
  }
  .btn-primary:hover {
    background: #FF8256;
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(255,110,60,0.4);
    animation: none;
  }
  .btn-primary:active { transform: scale(0.97); animation: none; }
  .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; animation: none; }

  .btn-ghost {
    display: inline-flex; align-items: center; gap: 8px;
    padding: 12px 26px; font-size: 14.5px; font-weight: 500;
    background: rgba(255,255,255,0.06);
    color: rgba(255,255,255,0.8);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 10px; cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    transition: all 0.2s ease;
  }
  .btn-ghost:hover {
    background: rgba(255,255,255,0.1);
    border-color: rgba(255,255,255,0.2);
    color: #fff;
  }

  .btn-nav {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 8px 20px; font-size: 13px; font-weight: 600;
    background: #FF6E3C; color: #fff; border: none; border-radius: 8px;
    cursor: pointer; font-family: 'DM Sans', sans-serif;
    transition: all 0.2s;
  }
  .btn-nav:hover { background: #FF8256; }

  /* Hero */
  .hero-bg {
    background: #0A0A0F;
    position: relative; overflow: hidden;
  }
  .hero-grid {
    position: absolute; inset: 0;
    background-image:
      linear-gradient(rgba(255,110,60,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,110,60,0.04) 1px, transparent 1px);
    background-size: 60px 60px;
  }
  .hero-glow {
    position: absolute;
    width: 600px; height: 600px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255,110,60,0.12) 0%, transparent 70%);
    top: -200px; left: 50%; transform: translateX(-50%);
    pointer-events: none;
  }

  /* Steps */
  .step-grid {
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px;
  }
  .step-card {
    background: #13131A;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 16px;
    overflow: hidden;
    transition: all 0.3s ease;
    position: relative;
  }
  .step-card::before {
    content: '';
    position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(255,110,60,0.06) 0%, transparent 60%);
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
    z-index: 1;
  }
  .step-card:hover {
    border-color: rgba(255,110,60,0.3);
    transform: translateY(-6px);
    box-shadow: 0 24px 48px rgba(0,0,0,0.4);
  }
  .step-card:hover::before { opacity: 1; }
  .step-image {
    width: 100%; height: 130px; object-fit: cover;
    filter: brightness(0.7) saturate(0.8);
    transition: filter 0.3s;
  }
  .step-card:hover .step-image { filter: brightness(0.85) saturate(1); }
  .step-content { padding: 16px 18px 20px; position: relative; z-index: 2; }

  /* Resume Zone */
  .resume-zone {
    border: 1.5px dashed rgba(255,255,255,0.12);
    border-radius: 20px;
    transition: all 0.25s ease;
    cursor: pointer;
    background: #13131A;
  }
  .resume-zone.drag-over {
    border-color: #FF6E3C;
    background: rgba(255,110,60,0.05);
    transform: scale(0.995);
  }
  .resume-zone:hover {
    border-color: rgba(255,110,60,0.3);
  }

  /* Score Circle */
  .score-circle {
    width: 130px; height: 130px; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto; position: relative;
  }
  .score-inner {
    width: 108px; height: 108px; background: #13131A;
    border-radius: 50%;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
  }
  .skill-tag {
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    padding: 5px 14px; border-radius: 30px;
    font-size: 12px; font-weight: 500; color: #ccc;
    transition: all 0.2s;
    display: inline-block;
  }
  .skill-tag:hover {
    background: rgba(255,110,60,0.15);
    border-color: rgba(255,110,60,0.4);
    color: #FF6E3C;
    transform: translateY(-2px);
  }

  /* Trust pills */
  .trust-pill {
    display: inline-flex; align-items: center; gap: 7px;
    font-size: 13px; color: rgba(255,255,255,0.55);
    font-weight: 500; padding: 8px 18px;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 30px; background: rgba(255,255,255,0.03);
    transition: all 0.2s;
  }
  .trust-pill:hover {
    border-color: rgba(255,110,60,0.3);
    background: rgba(255,110,60,0.06);
    color: #FF6E3C;
  }

  /* Section label */
  .section-label {
    font-size: 11px; font-weight: 600;
    letter-spacing: 3px; text-transform: uppercase;
    color: #FF6E3C; margin-bottom: 12px;
  }

  /* Scan overlay effect on images */
  .scan-wrapper {
    position: relative; overflow: hidden;
  }
  .scan-wrapper::after {
    content: '';
    position: absolute; left: 0; right: 0; height: 2px;
    background: linear-gradient(90deg, transparent, rgba(255,110,60,0.6), transparent);
    animation: scanLine 3s ease-in-out infinite;
    top: 0;
  }

  /* Number badge */
  .step-num {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 800;
    color: rgba(255,255,255,0.06);
    letter-spacing: -2px;
    line-height: 1;
  }

  @media (max-width: 900px) {
    .hn-nav-links { display: none; }
    .step-grid { grid-template-columns: repeat(2, 1fr); }
    .hn-nav { padding: 0 20px; }
  }
  @media (max-width: 550px) {
    .step-grid { grid-template-columns: 1fr; }
  }
`;

const steps = [
  {
    icon: '✉️', title: 'Email Verification', desc: 'Confirm your registered email to proceed.',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&h=200&fit=crop'
  },
  {
    icon: '📋', title: 'Disclaimer & Consent', desc: 'Review and accept the AI Interview terms.',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=200&fit=crop'
  },
  {
    icon: '🔐', title: 'OTP Verification', desc: 'Verify your identity via one-time password.',
    image: 'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=400&h=200&fit=crop'
  },
  {
    icon: '📄', title: 'Review Details', desc: 'Confirm your schedule and role information.',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=200&fit=crop'
  },
  {
    icon: '🖥️', title: 'System Check', desc: 'Ensure camera, mic and internet are ready.',
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&h=200&fit=crop'
  },
  {
    icon: '📸', title: 'Photo Capture', desc: 'Quick face scan for identity verification.',
    image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=200&fit=crop'
  },
  {
    icon: '🎤', title: 'Mic Test', desc: 'Verify your microphone works clearly.',
    image: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=400&h=200&fit=crop'
  },
  {
    icon: '🤖', title: 'Start Interview', desc: "All set — your AI Interview begins now!",
    image: 'https://images.unsplash.com/photo-1677442135968-6db3b0025e95?w=400&h=200&fit=crop'
  },
];

const tickerItems = [
  'AI-Powered Interview Platform',
  'End-to-End Encrypted',
  'AI Proctored & Secure',
  '8 Simple Setup Steps',
  'Stable Connection Required',
  'Privacy Protected',
  'AI-Powered Interview Platform',
  'End-to-End Encrypted',
];

const tips = [
  { icon: '💡', text: 'Keep your face well-lit and visible throughout' },
  { icon: '🎧', text: 'Use headphones to reduce background noise' },
  { icon: '📶', text: 'Ensure a stable internet connection before starting' },
  { icon: '🕐', text: 'Set aside the full duration — avoid interruptions' },
];
const API_URL = process.env.REACT_APP_API_BASE_URL;

const analyzeResume = async (file) => {
  const formData = new FormData();
  formData.append('resume', file);

  try {
    const response = await fetch(`${API_URL}/api/resume/analyze`, {
      method: 'POST',
      body: formData,
    });

    const result = await response.json();

    if (result.success) {
      return result.data;
    } else {
      throw new Error(result.message);
    }
  } catch (error) {
    console.error('Analysis error:', error);
    throw error;
  }
};

const InterviewLandingPage = () => {
  const { interviewId } = useParams();
  const navigate = useNavigate();
  const [token] = useState(new URLSearchParams(window.location.search).get('token'));
  const [tipIndex, setTipIndex] = useState(0);
  const [starting, setStarting] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeNav, setActiveNav] = useState('home');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [resumeFile, setResumeFile] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => setTipIndex(i => (i + 1) % tips.length), 3500);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropdownOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleStart = () => {
    setStarting(true);
    setTimeout(() => {
      navigate(`/interview/${interviewId || 'demo'}/prerequisites${token ? `?token=${token}` : ''}`);
    }, 500);
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setActiveNav(id);
    setDropdownOpen(false);
  };

  const handleFileSelect = async (file) => {
    if (!file.type.includes('pdf') && !file.type.includes('msword') && !file.type.includes('openxmlformats') && !file.type.includes('text/plain')) {
      alert('Please upload a PDF, DOC, DOCX, or TXT file');
      return;
    }
    setResumeFile(file);
    setIsAnalyzing(true);
    setAnalysisResult(null);
    try {
      const result = await analyzeResume(file);
      setAnalysisResult(result);
    } catch (error) {
      alert('Analysis failed. Please try again.');
    } finally {
      setIsAnalyzing(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) handleFileSelect(file);
  };

  const resetAnalysis = () => {
    setResumeFile(null);
    setAnalysisResult(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  useEffect(() => {
    if (analysisResult) {
      const el = document.querySelector('.score-circle');
      if (el) {
        const deg = (analysisResult.score / 100) * 360;
        el.style.background = `conic-gradient(#FF6E3C ${deg}deg, rgba(255,255,255,0.06) ${deg}deg)`;
      }
    }
  }, [analysisResult]);

  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0F', fontFamily: "'DM Sans', sans-serif" }}>
      <style>{globalStyles}</style>

      {/* NAVBAR */}
      <nav className={`hn-nav ${scrolled ? 'scrolled' : ''}`}>
        <a className="hn-logo" onClick={() => scrollTo('home')}>
          <span></span>Humanex<div className="hn-logo-dot" />
        </a>

        <div className="hn-nav-links">
          <button className={`hn-nav-link ${activeNav === 'home' ? 'active' : ''}`} onClick={() => scrollTo('home')}>Home</button>
          <button className={`hn-nav-link ${activeNav === 'steps' ? 'active' : ''}`} onClick={() => scrollTo('steps')}>How It Works</button>
          <button className={`hn-nav-link ${activeNav === 'resume' ? 'active' : ''}`} onClick={() => scrollTo('resume')}>Resume Scanner</button>

          <div className="dropdown" ref={dropdownRef}>
            <button className="dropdown-btn" onClick={() => setDropdownOpen(!dropdownOpen)}>
              More <span style={{ fontSize: '11px', transition: 'transform 0.2s', display: 'inline-block', transform: dropdownOpen ? 'rotate(180deg)' : 'none' }}>▼</span>
            </button>
            <div className={`dropdown-content ${dropdownOpen ? 'open' : ''}`}>
              <a onClick={() => scrollTo('testimonials')}>⭐ Candidate Reviews</a>
              <a onClick={() => scrollTo('faq')}>❓ FAQ</a>
              <a onClick={() => scrollTo('resources')}>📘 Resources</a>
              <a onClick={() => scrollTo('security')}>🔒 Security & Privacy</a>
            </div>
          </div>
        </div>

        <div className="hn-nav-right">
          <span style={{
            fontSize: 12, fontWeight: 600,
            color: 'rgba(255,110,60,0.9)',
            padding: '5px 12px',
            border: '1px solid rgba(255,110,60,0.25)',
            borderRadius: 8,
            background: 'rgba(255,110,60,0.08)',
            display: 'inline-flex', alignItems: 'center', gap: 5,
          }}>
            🤖 AI Mode
          </span>
          <button className="btn-nav" onClick={handleStart}>Begin →</button>
        </div>
      </nav>

      {/* TICKER */}
      <div className="ticker-bar">
        <div className="ticker-track">
          {tickerItems.map((item, i) => (
            <span key={i} className="ticker-item">
              <span className="ticker-dot">◆</span>
              {item}
            </span>
          ))}
        </div>
      </div>

      {/* HERO */}
      <div id="home" className="hero-bg" style={{ padding: '90px 24px 80px' }}>
        <div className="hero-grid" />
        <div className="hero-glow" />

        <div style={{ maxWidth: 860, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 2 }}>

          {/* Status badge */}
          <div className="fade-1" style={{ marginBottom: 28 }}>
            <span style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              fontSize: 12, fontWeight: 600, letterSpacing: '0.08em',
              textTransform: 'uppercase', color: 'rgba(255,255,255,0.5)',
              padding: '8px 20px',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 30, background: 'rgba(255,255,255,0.04)',
            }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#4ADE80', display: 'inline-block', animation: 'pulse 2s ease infinite' }} />
              AI Interview Platform · Live
            </span>
          </div>

          <div className="fade-1">
            <h1 style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: 68, fontWeight: 800,
              color: '#FFFFFF',
              lineHeight: 1.05, marginBottom: 24,
              letterSpacing: '-3px',
            }}>
              Your AI-Powered
              <br />
              <span style={{ color: '#FF6E3C' }}>Interview</span> Portal
            </h1>
          </div>

          <div className="fade-2">
            <p style={{
              fontSize: 17, color: 'rgba(255,255,255,0.5)',
              maxWidth: 520, margin: '0 auto 44px',
              lineHeight: 1.8, fontWeight: 400,
            }}>
              Complete 8 quick setup steps and enter your AI interview fully prepared — takes less than 5 minutes.
            </p>
          </div>

          <div className="fade-3" style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 52 }}>
            <button className="btn-primary" onClick={handleStart} disabled={starting}>
              {starting
                ? <><div style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)', borderTop: '2px solid #fff', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} /> Preparing...</>
                : <>🚀 Begin Preparation — It's Quick</>
              }
            </button>
            <button className="btn-ghost" onClick={() => scrollTo('steps')}>
              View 8 Steps ↓
            </button>
          </div>

          {/* Stats row */}
          <div className="fade-4" style={{ display: 'flex', justifyContent: 'center', gap: 40, flexWrap: 'wrap' }}>
            {[['10K+', 'Candidates Assessed'], ['98%', 'Completion Rate'], ['~5 min', 'Setup Time'], ['256-bit', 'Encryption']].map(([val, label], i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <div style={{ fontFamily: "'Poppins', sans-serif", fontSize: 26, fontWeight: 800, color: '#fff', letterSpacing: '-1px' }}>{val}</div>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', fontWeight: 500, marginTop: 3, letterSpacing: '0.04em' }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* TRUST PILLS */}
      <div id="features" style={{
        background: '#0D0D14',
        borderTop: '1px solid rgba(255,255,255,0.05)',
        borderBottom: '1px solid rgba(255,255,255,0.05)',
        padding: '20px 24px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 10, flexWrap: 'wrap' }}>
          {[
            { icon: '🔒', label: 'Encrypted & Secure' },
            { icon: '🎥', label: 'AI Proctored' },
            { icon: '⚡', label: 'Real-time Evaluation' },
            { icon: '🛡️', label: 'Privacy Protected' },
            { icon: '✅', label: '8 Simple Steps' },
            { icon: '⏱️', label: '~5 Minutes Setup' },
          ].map((item, i) => (
            <div key={i} className="trust-pill">
              <span style={{ fontSize: 13 }}>{item.icon}</span>
              {item.label}
            </div>
          ))}
        </div>
      </div>

      {/* RESUME SCANNER */}
      <div id="resume" style={{ background: '#0A0A0F', padding: '80px 24px', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ maxWidth: 1060, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div className="section-label">Resume Analyzer</div>
            <h2 style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: 40, fontWeight: 800,
              color: '#fff', letterSpacing: '-1.5px', marginBottom: 14,
            }}>
              AI-Powered Resume Scanner
            </h2>
            <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.4)', maxWidth: 520, margin: '0 auto', lineHeight: 1.7 }}>
              Upload your resume for instant analysis — get a score, skill breakdown, and personalized job recommendations.
            </p>
          </div>

          <div
            className={`resume-zone ${dragOver ? 'drag-over' : ''}`}
            onDrop={handleDrop}
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onClick={() => fileInputRef.current?.click()}
            style={{ padding: '48px 36px' }}
          >
            <input
              type="file" ref={fileInputRef} style={{ display: 'none' }}
              accept=".pdf,.doc,.docx,.txt"
              onChange={(e) => { if (e.target.files?.[0]) handleFileSelect(e.target.files[0]); }}
            />

            {!resumeFile && !isAnalyzing && !analysisResult && (
              <div style={{ textAlign: 'center' }}>
                <div style={{
                  width: 72, height: 72, margin: '0 auto 20px',
                  background: 'rgba(255,110,60,0.1)',
                  borderRadius: 18, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 32, border: '1px solid rgba(255,110,60,0.2)',
                  animation: 'float 3s ease infinite',
                }}>📄</div>
                <h3 style={{ fontSize: 20, fontWeight: 600, color: '#fff', marginBottom: 8 }}>
                  Drag & drop your resume here
                </h3>
                <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14, marginBottom: 24 }}>
                  Supports PDF, DOC, DOCX, TXT — Max 5MB
                </p>
                <button className="btn-ghost" style={{ padding: '10px 24px', fontSize: 13 }} onClick={e => e.stopPropagation()}>
                  Browse files
                </button>
              </div>
            )}

            {isAnalyzing && (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <div style={{ width: 52, height: 52, margin: '0 auto 24px', border: '2.5px solid rgba(255,255,255,0.06)', borderTop: '2.5px solid #FF6E3C', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                <h3 style={{ fontSize: 18, fontWeight: 600, color: '#fff' }}>Analyzing your resume...</h3>
                <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 13, marginTop: 8 }}>
                  AI is extracting skills and matching job roles
                </p>
              </div>
            )}

            {analysisResult && !isAnalyzing && (
              <div style={{ textAlign: 'left' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 28 }}>
                  {/* Score */}
                  <div style={{ textAlign: 'center', minWidth: 150 }}>
                    <div className="score-circle">
                      <div className="score-inner">
                        <span style={{ fontSize: 36, fontWeight: 800, color: '#fff', fontFamily: "'Poppins', sans-serif" }}>{analysisResult.score}</span>
                        <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginTop: 2 }}>/ 100</span>
                      </div>
                    </div>
                    <p style={{ fontSize: 13, fontWeight: 600, marginTop: 14, color: 'rgba(255,255,255,0.7)' }}>Resume Score</p>
                    <button onClick={resetAnalysis} style={{ marginTop: 16, background: 'none', border: 'none', color: '#FF6E3C', fontSize: 12, cursor: 'pointer' }}>
                      Analyze another →
                    </button>
                  </div>

                  {/* Skills & Summary */}
                  <div style={{ flex: 1 }}>
                    <div style={{ marginBottom: 20 }}>
                      <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: '0.08em', fontSize: 11 }}>Extracted Skills</h4>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {analysisResult.skills.map((skill, idx) => (
                          <span key={idx} className="skill-tag">{skill}</span>
                        ))}
                      </div>
                    </div>
                    <div>
                      <h4 style={{ fontSize: 11, fontWeight: 600, marginBottom: 10, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>AI Summary</h4>
                      <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.55)', lineHeight: 1.65, background: 'rgba(255,255,255,0.04)', padding: '14px 16px', borderRadius: 12, border: '1px solid rgba(255,255,255,0.07)' }}>
                        {analysisResult.summary}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Roles */}
                <div style={{ marginTop: 32 }}>
                  <h4 style={{ fontSize: 11, fontWeight: 600, marginBottom: 16, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Best Fit Job Roles</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14 }}>
                    {analysisResult.suitableRoles.map((role, idx) => (
                      <div key={idx} style={{ border: '1px solid rgba(255,255,255,0.08)', borderRadius: 14, padding: 18, background: 'rgba(255,255,255,0.02)', transition: 'all 0.2s' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                          <span style={{ fontWeight: 700, fontSize: 15, color: '#fff' }}>{role.title}</span>
                          <span style={{ background: 'rgba(255,110,60,0.12)', color: '#FF6E3C', padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>{role.match}%</span>
                        </div>
                        <p style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.4)', lineHeight: 1.55 }}>{role.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Recommendations */}
                <div style={{ marginTop: 28, background: 'rgba(255,110,60,0.05)', borderRadius: 14, padding: '18px 20px', border: '1px solid rgba(255,110,60,0.12)' }}>
                  <h4 style={{ fontSize: 11, fontWeight: 600, marginBottom: 12, color: '#FF6E3C', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Personalized Recommendations</h4>
                  <ul style={{ marginLeft: 18, color: 'rgba(255,255,255,0.5)', fontSize: 13, lineHeight: 1.8 }}>
                    {analysisResult.recommendations.map((rec, idx) => (
                      <li key={idx} style={{ marginBottom: 5 }}>{rec}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* STEPS */}
      <div id="steps" style={{ background: '#0D0D14', padding: '80px 24px' }}>
        <div style={{ maxWidth: 1060, margin: '0 auto' }}>

          {/* Tip banner */}
          <div style={{
            background: 'rgba(255,110,60,0.06)',
            border: '1px solid rgba(255,110,60,0.15)',
            borderRadius: 12, padding: '13px 20px',
            display: 'flex', alignItems: 'center', gap: 12,
            marginBottom: 56, maxWidth: 580, margin: '0 auto 56px',
          }}>
            <span style={{ fontSize: 18 }}>{tips[tipIndex].icon}</span>
            <span key={tipIndex} style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.6)', fontWeight: 500, animation: 'fadeIn 0.4s ease' }}>
              {tips[tipIndex].text}
            </span>
          </div>

          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div className="section-label">What to Expect</div>
            <h2 style={{
              fontFamily: "'Poppins', sans-serif",
              fontSize: 40, fontWeight: 800, color: '#fff',
              letterSpacing: '-1.5px', marginTop: 10, marginBottom: 12,
            }}>
              8 Steps to Your Interview
            </h2>
            <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.4)', fontWeight: 400 }}>
              Complete each step in order — we'll guide you through every one.
            </p>
          </div>

          <div className="step-grid" style={{ marginBottom: 56 }}>
            {steps.map((s, i) => {
              const isLast = i === steps.length - 1;
              return (
                <div key={i} className="step-card">
                  <div className="scan-wrapper">
                    <img src={s.image} alt={s.title} className="step-image" loading="lazy" />
                    {isLast && (
                      <div style={{
                        position: 'absolute', inset: 0,
                        background: 'linear-gradient(135deg, rgba(255,110,60,0.3) 0%, transparent 60%)',
                      }} />
                    )}
                  </div>
                  <div className="step-content">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                      <div style={{
                        width: 38, height: 38, borderRadius: 10,
                        background: isLast ? '#FF6E3C' : 'rgba(255,255,255,0.06)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
                        border: isLast ? 'none' : '1px solid rgba(255,255,255,0.08)',
                      }}>{s.icon}</div>
                      <span className="step-num">{String(i + 1).padStart(2, '0')}</span>
                    </div>
                    <div style={{ fontSize: 13.5, fontWeight: 600, color: '#fff', marginBottom: 5 }}>{s.title}</div>
                    <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', lineHeight: 1.6 }}>{s.desc}</div>
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ textAlign: 'center' }}>
            <button className="btn-primary" onClick={handleStart} disabled={starting} style={{ fontSize: 15, padding: '15px 42px' }}>
              {starting
                ? <><div style={{ width: 18, height: 18, border: '2px solid rgba(255,255,255,0.3)', borderTop: '2px solid #fff', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} /> Preparing...</>
                : <>🚀 Start Your Journey →</>
              }
            </button>
            <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.2)', marginTop: 14, fontWeight: 400 }}>
              All 8 steps · ~5 minutes · 100% secure
            </p>
          </div>
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div id="testimonials" style={{ padding: '72px 24px', background: '#0A0A0F', borderTop: '1px solid rgba(255,255,255,0.05)', textAlign: 'center' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <div className="section-label">Candidate Reviews</div>
          <h3 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 28, fontWeight: 800, color: '#fff', marginTop: 10, marginBottom: 32 }}>
            What Candidates Say
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 16 }}>
            {[
              { quote: '"The resume scanner gave me insights I never considered. Got the job!"', name: 'Priya M.', role: 'Software Engineer' },
              { quote: '"AI interview felt natural and fair. The skill match was spot on."', name: 'Rahul K.', role: 'Data Analyst' },
            ].map((t, i) => (
              <div key={i} style={{ background: '#13131A', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: '24px', textAlign: 'left' }}>
                <div style={{ fontSize: 24, color: '#FF6E3C', marginBottom: 12, fontFamily: 'serif' }}>"</div>
                <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, lineHeight: 1.7, marginBottom: 16 }}>{t.quote.replace(/^"|"$/g, '')}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(255,110,60,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: '#FF6E3C', fontWeight: 700 }}>
                    {t.name[0]}
                  </div>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#fff' }}>{t.name}</div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)' }}>{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div id="faq" style={{ padding: '72px 24px', background: '#0D0D14', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ maxWidth: 680, margin: '0 auto' }}>
          <div className="section-label" style={{ textAlign: 'center' }}>FAQ</div>
          <h3 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 28, fontWeight: 800, color: '#fff', textAlign: 'center', marginTop: 10, marginBottom: 36 }}>
            Frequently Asked Questions
          </h3>
          {[
            { q: 'How long does setup take?', a: 'Typically 4-6 minutes for all 8 steps.' },
            { q: 'Is my resume data secure?', a: "Yes, we don't store resumes. Analysis happens in real-time and data is deleted after session." },
            { q: 'What if I disconnect?', a: 'Auto-save technology lets you resume exactly where you left off.' },
          ].map((item, i) => (
            <div key={i} style={{ borderBottom: '1px solid rgba(255,255,255,0.06)', paddingBottom: 20, marginBottom: 20 }}>
              <div style={{ fontWeight: 600, color: '#fff', fontSize: 15, marginBottom: 8 }}>{item.q}</div>
              <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14, lineHeight: 1.65 }}>{item.a}</p>
            </div>
          ))}
        </div>
      </div>

      {/* RESOURCES */}
      <div id="resources" style={{ padding: '60px 24px', background: '#0A0A0F', textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <div className="section-label">Resources</div>
        <h3 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 28, fontWeight: 800, color: '#fff', marginTop: 10, marginBottom: 12 }}>
          Guides & Resources
        </h3>
        <p style={{ color: 'rgba(255,255,255,0.35)', marginTop: 8, maxWidth: 500, margin: '8px auto 0', lineHeight: 1.7 }}>
          Interview tips, technical guides, and best practices available in our help center.
        </p>
      </div>

      {/* SECURITY */}
      <div id="security" style={{ padding: '60px 24px', textAlign: 'center', background: '#0D0D14', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <div className="section-label">Security</div>
        <h3 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 28, fontWeight: 800, color: '#fff', marginTop: 10, marginBottom: 12 }}>
          Enterprise-Grade Security
        </h3>
        <p style={{ color: 'rgba(255,255,255,0.35)', maxWidth: 500, margin: '12px auto 0', lineHeight: 1.7 }}>
          SOC2 Type II compliant, GDPR ready, and bank-level encryption for all interview sessions.
        </p>
      </div>

      {/* FOOTER */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: '24px', textAlign: 'center', background: '#0A0A0F' }}>
        <p style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.2)', fontWeight: 400 }}>
          Powered by <strong style={{ color: 'rgba(255,255,255,0.5)', fontWeight: 600 }}>Humanex AI</strong> · Secure Interview Platform
        </p>
      </div>
    </div>
  );
};

export default InterviewLandingPage;